import "tailwindcss/tailwind.css"
import { User, addUserSelected, onResizeHead } from './users'

const coin = document.getElementById("coin")
const text_section = document.getElementById("text-section")

document.documentElement.style.setProperty('--scrollbar-width', `${window.innerWidth - document.documentElement.clientWidth}px`);

addUserSelected((user?: User) => {
  if (!coin) {
    return
  }

  if (user) {
    history.replaceState(null, "", `#${user.number.toString()}`);
  } else {
    history.replaceState(null, "", `#`);
  }
})

const onResize = () => {
  onResizeHead()

  if (!coin || !text_section) {
    return
  }

  const text_section_height = text_section.getBoundingClientRect().height
  const coin_height = coin.getBoundingClientRect().height

  document.documentElement.style.setProperty('--padding', `calc(max(var(--vh) * 50 + ${text_section_height + coin_height / 2 - window.innerHeight + 50}px, var(--vh) * 50))`);

  text_section.style.bottom = text_section_height >= window.innerHeight ? "unset" : "0"
}

window.addEventListener("resize", onResize)
onResize()